module.exports = __webpack_public_path__ + "static/black1-29ddae0472291347e3521eab7c97d367.png";